import { useCallback, useState, useEffect } from "react";
import TableButton from "components/atoms/buttons/TableButton";
import { useQuery } from "react-query";
import { useAppSelector } from "redux/hooks";
import {
  ProfileAccountInfo,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import {
  GetAlertActiveListResponse,
  ActiveAlert,
  AlertActiveSummary,
} from "api/interfaces/alertInterface.interface";
import {
  SORT_DIRECTION,
  BasePagination,
  DefaultQueryParam,
} from "api/interfaces/commonInterface.interface";
import { getAlertActiveList } from "api/alertAPI";
import {
  Location,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import TableColumnFilterTitle from "components/blocks/table/TableColumnFilterTitle";
import {
  ActiveAlertStatusTypeFilter,
  AlertCategoryTypeFilter,
  navigateAlertDetailPage,
} from "utils/AlertUtil";
import * as s from "../AlertStyled";
import RecorderTitle from "components/blocks/recorder/RecorderTitle";
import { isNull } from "lodash";
import { TableColumnsType } from "antd";
import {
  changeSortOrderAntd,
  CommonTable,
  onSortAntd,
} from "components/atoms/table/AntdTable";
import { ColumnType } from "antd/lib/table";
import { SortOrder } from "antd/lib/table/interface";
import { InitialAlertSummary } from "../AlertPage";
import TimeText from "components/atoms/text/TimeText";
import AlertDisplay from "components/blocks/status/AlertDisplay";
import { baseQueryInfo, useQueryKey } from "utils/queryUtil";
import { useMenu } from "hook/useMenu";
import AccountInfoLabel from "components/atoms/text/labels/AccountInfoLabel";
import * as mediaQuery from "components/MediaQuery";
import useApiError from "hook/useApiError";
import { useAlertRules } from "hook/useAlertRules";
import NoAlertRule from "components/blocks/NoAlertRule";
import useStompDebouncedRefetch, {
  StompDateSignalKey,
} from "hook/useStompDebouncedRefetch";

const initialQueryInfo = {
  ...baseQueryInfo,
  sortType: "alert_trigger",
  sortDirection: SORT_DIRECTION.DESC,
  status: null,
  type: null,
};

export default function AlertActive(): JSX.Element {
  const navigate = useNavigate();
  const location: Location = useLocation();
  const { queryNavigate } = useMenu({});
  const { hasAlertRuleList, alertRuleQuery } = useAlertRules({});
  const isBigScreen = mediaQuery.useIsBigScreen();
  const { setTotalCount, pending, setPending, onChangeStatusAlertSummary } =
    useOutletContext<any>();

  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  const [alertList, setAlertList] = useState<ActiveAlert[]>([]);

  const [alertActiveQueryInfo, setAlertActiveQueryInfo] =
    useState<BasePagination>({
      ...initialQueryInfo,
    });
  const queryKey = useQueryKey(alertActiveQueryInfo);
  const isMobile = mediaQuery.useIsMobile();
  const isDesktop = mediaQuery.useIsDesktop();
  const { lang, notifyError } = useApiError();
  useEffect(() => {
    const changeParam = new URLSearchParams(location.search);
    if (changeParam.size > 0) {
      setAlertActiveQueryInfo((info) => {
        return {
          ...info,
          pageNum: isNull(changeParam.get("pageNum"))
            ? 0
            : Number(changeParam.get("pageNum")),
          pageLimit: isNull(changeParam.get("pageLimit"))
            ? 20
            : Number(changeParam.get("pageLimit")),
          keyword: isNull(changeParam.get("keyword"))
            ? ""
            : (changeParam.get("keyword") as string),
          sortType: isNull(changeParam.get("sortType"))
            ? "alert_trigger"
            : (changeParam.get("sortType") as string),
          sortDirection: isNull(changeParam.get("sortDirection"))
            ? SORT_DIRECTION.DESC
            : (changeParam.get("sortDirection") as SORT_DIRECTION),
          type: isNull(changeParam.get("type"))
            ? null
            : (changeParam.get("type") as string),
          status: isNull(changeParam.get("status"))
            ? null
            : (changeParam.get("status") as string),
        };
      });
    } else {
      setAlertActiveQueryInfo((info) => {
        return {
          ...initialQueryInfo,
        };
      });
    }
  }, [location]);

  const onClickAlertCategoryType = useCallback(
    (value: string | undefined) => {
      if (value !== undefined) {
        if (value === "all") {
          if (alertActiveQueryInfo.type !== undefined) {
            queryNavigate({
              to: location.pathname,
              queryInfo: {
                pageLimit: alertActiveQueryInfo.pageLimit,
                pageNum: 0,
                keyword: alertActiveQueryInfo.keyword as string,
                sortType: alertActiveQueryInfo.sortType,
                sortDirection:
                  alertActiveQueryInfo.sortDirection as SORT_DIRECTION,
                type: null,
                status: alertActiveQueryInfo.status,
              },
            });
          } else {
            refetch();
          }
          // setAlertActiveQueryInfo((info) => {
          //   return { ...info, type: null, pageNum: 0 };
          // });
        } else {
          if (alertActiveQueryInfo.type !== value) {
            queryNavigate({
              to: location.pathname,
              queryInfo: {
                pageLimit: alertActiveQueryInfo.pageLimit,
                pageNum: 0,
                keyword: alertActiveQueryInfo.keyword as string,
                sortType: alertActiveQueryInfo.sortType,
                sortDirection:
                  alertActiveQueryInfo.sortDirection as SORT_DIRECTION,
                type: value,
                status: alertActiveQueryInfo.status,
              },
            });
          } else {
            refetch();
          }
          // setAlertActiveQueryInfo((info) => {
          //   return { ...info, type: value as string, pageNum: 0 };
          // });
        }
      }
    },
    [
      alertActiveQueryInfo.keyword,
      alertActiveQueryInfo.pageLimit,
      alertActiveQueryInfo.sortDirection,
      alertActiveQueryInfo.sortType,
      alertActiveQueryInfo.status,
      alertActiveQueryInfo.type,
      location.pathname,
      queryNavigate,
    ]
  );
  const onHeaderCell = (column: ColumnType<ActiveAlert>) => {
    return {
      onClick: () => {
        queryNavigate({
          to: location.pathname,
          queryInfo: {
            ...alertActiveQueryInfo,
            sortType: column.key as string,
            sortDirection: onSortAntd(alertActiveQueryInfo.sortDirection),
            pageNum: 0,
          },
        });
      },
    };
  };
  const onClickAlertStatusType = useCallback(
    (value: string | undefined) => {
      if (value !== undefined) {
        if (value === "all") {
          if (alertActiveQueryInfo.status !== null) {
            queryNavigate({
              to: location.pathname,
              queryInfo: {
                ...alertActiveQueryInfo,
                pageNum: 0,
                status: null,
              },
            });
          } else {
            refetch();
          }
          // setAlertActiveQueryInfo((info) => {
          //   return { ...info, status: null, pageNum: 0 };
          // });
        } else {
          if (alertActiveQueryInfo.status !== value) {
            queryNavigate({
              to: location.pathname,
              queryInfo: {
                ...alertActiveQueryInfo,
                pageNum: 0,
                status: value,
              },
            });
          } else {
            refetch();
          }
          // setAlertActiveQueryInfo((info) => {
          //   return { ...info, status: value as string, pageNum: 0 };
          // });
        }
      }
    },
    [
      alertActiveQueryInfo.keyword,
      alertActiveQueryInfo.pageLimit,
      alertActiveQueryInfo.sortDirection,
      alertActiveQueryInfo.sortType,
      alertActiveQueryInfo.status,
      alertActiveQueryInfo.type,
      location.pathname,
      queryNavigate,
    ]
  );
  const columns: TableColumnsType<ActiveAlert> = [
    {
      title: (
        <TableColumnFilterTitle
          title="Category"
          filters={AlertCategoryTypeFilter}
          onClick={onClickAlertCategoryType}
          data-testid="alert-active-active-table-column-filter-title-click-alert-category-type"
        />
      ),

      render: (value: any, row: ActiveAlert) => row.type,
      width: isMobile ? 50 : 110,
    },
    {
      title: "Recorder",
      // grow: 1.5,
      render: (value: any, row: ActiveAlert) => (
        <RecorderTitle
          mergedSystemName={row.mergedSystemName}
          recorderName={row.recorderName}
          type={row.recorderType}
          isShowType={true}
          displayType={row.displayType}
          licenseType={row.licenseType}
          isCloudCam={row.isCloudCam}
        />
      ),

      width: !isDesktop ? undefined : "30%",
    },
    {
      title: (
        <TableColumnFilterTitle
          title="Status"
          filters={ActiveAlertStatusTypeFilter}
          onClick={onClickAlertStatusType}
          data-testid="alert-active-active-table-column-filter-title-click-alert-status-type"
        />
      ),

      // grow: 1,
      render: (value: any, row: ActiveAlert) => (
        <s.StatusTxt string={row.status.toUpperCase()}>
          {row.status}
        </s.StatusTxt>
      ),

      width: isMobile ? 50 : 100,
    },
    {
      title: "Organization",
      // grow: 1.5,
      render: (value: any, row: ActiveAlert) => (
        <AccountInfoLabel
          level={LEVEL_TYPE.EU}
          accountNumber={row.accountNumber}
          accountName={row.accountName}
          direction={isBigScreen ? "row" : "column"}
        />
      ),

      hidden: selectedAccount.accountLevel === "EU",
      width: isBigScreen ? "15%" : isDesktop ? 150 : 100,
    },
    {
      title: "Alert",
      // grow: 2,
      render: (value: any, row: ActiveAlert) => (
        <AlertDisplay
          alertType={row.alertTypeString || String(row.alertType)}
          alertTypeString={row.alertTypeString}
          cameraName={row.cameraName}
          channel={row.cameraChannel}
        />
      ),

      responsive: ["xl"],
    },
    {
      title: "Date",
      dataIndex: "alertTrigger",
      key: "alert_trigger",
      sorter: true,
      sortOrder: changeSortOrderAntd(
        alertActiveQueryInfo,
        "alert_trigger"
      ) as SortOrder,
      onHeaderCell: onHeaderCell,
      render: (value: any, row: ActiveAlert) =>
        row.alertTrigger !== undefined ? (
          <TimeText
            times={row.alertTrigger}
            timezone={row.timezone}
            selectedAccount={selectedAccount}
            isThumbnail={true}
          />
        ) : (
          ""
        ),

      width: isDesktop
        ? selectedAccount.accountLevel === "EU"
          ? 185
          : "10%"
        : 120,
      responsive: selectedAccount.accountLevel === "EU" ? ["sm"] : ["lg"],
    },
    {
      title: "Assignee",
      // grow: 1,
      render: (value: any, row: ActiveAlert) => row.assignee,
      responsive: ["xxl"],
      width: 200,
    },
    {
      title: "",
      // width: "175px",
      // grow: 2,
      render: (value: any, row: ActiveAlert) => (
        <s.Row className="table-button-wrapper">
          {/* <span className="row-click-button"> */}
          <TableButton
            buttonType="view"
            label={!isDesktop ? "View" : "View Alerts"}
            onClick={() => onRowClick(row)}
            // disabled={
            //   row.systemCount + row.diskCount + row.videoCount === 0
            //     ? true
            //     : false
            // }
            // onClick={() => onModal("view")}
            data-testid="alert-active-active-table-button-row"
          />
          {/* </span> */}
        </s.Row>
      ),

      align: "right",
      width: isMobile ? 40 : isDesktop ? 120 : 80,
    },
  ];

  const onRowClick = (row: ActiveAlert) => {
    navigateAlertDetailPage({
      location,
      navigate,
      accountId: selectedAccount.accountId as string,
      recorderId: row.recorderId,
      historyId: row.alertHistoryId,
      alertType: row.type,
      cameraId: row.cameraId,
      channel: row.cameraChannel,
    });
  };
  const { refetch } = useQuery(
    ["activeAlert", queryKey, selectedAccount.accountId],
    () =>
      getAlertActiveList({
        accountId: selectedAccount.accountId,
        payload: alertActiveQueryInfo,
      }),
    {
      retry: 0,
      refetchOnWindowFocus: false,
      onSuccess: (res: GetAlertActiveListResponse) => {
        if (res.error !== 0 && res.result?.alerts === undefined) {
          setAlertList([]);
          setTotalCount(0);
          setAlertActiveQueryInfo((info) => {
            return {
              ...info,
              ...initialQueryInfo,
            };
          });
          onChangeStatusAlertSummary(InitialAlertSummary);
        } else {
          onChangeStatusAlertSummary(res.result as AlertActiveSummary);
          setAlertList(
            (res.result.alerts || []).map((alert, index) => ({
              ...alert,
              key: index,
            }))
          );
          setTotalCount(res.page.total);
          setAlertActiveQueryInfo((info) => {
            return {
              ...info,
              ...res.page,
            };
          });
        }
      },
      onError: (err: any) => {
        setAlertList([]);
        setTotalCount(0);
        setAlertActiveQueryInfo((info) => {
          return {
            ...initialQueryInfo,
          };
        });
        onChangeStatusAlertSummary(InitialAlertSummary);
        notifyError(lang.label.alert.notify.list.error);
      },
      onSettled: (e: any) => {
        setPending(false);
      },
    }
  );

  const onChangePage = useCallback(
    (page: number, totalRows: number) => {
      if (page !== alertActiveQueryInfo.pageNum + 1) {
        queryNavigate({
          to: location.pathname,
          queryInfo: {
            ...alertActiveQueryInfo,
            pageNum: page - 1,
          },
        });
        setPending(true);
      }
    },
    [
      alertActiveQueryInfo.keyword,
      alertActiveQueryInfo.pageLimit,
      alertActiveQueryInfo.pageNum,
      alertActiveQueryInfo.sortDirection,
      alertActiveQueryInfo.sortType,
      location.pathname,
      queryNavigate,
    ]
  );
  useStompDebouncedRefetch({
    stompKey: [
      "alertListUpdated",
      "alertRuleListUpdated",
    ] as StompDateSignalKey[],
    refetch: refetch,
  });

  if (!hasAlertRuleList && !alertRuleQuery.isLoading) {
    return (
      <div style={{ paddingTop: 50 }}>
        <NoAlertRule />
      </div>
    );
  }

  return (
    <CommonTable
      columns={columns as TableColumnsType<ActiveAlert>}
      dataSource={alertList}
      queryInfo={alertActiveQueryInfo}
      onChangePage={onChangePage}
      loading={pending}
    />
  );
}
